import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import CenteredSpinner from './CenteredSpinner';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getAddressFullName } from '../Utils';

export const AddBuyerProperties = () => {
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [staffMemberId] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [searchPastBuyer, setSearchPastBuyer] = useState(null);
  //PastBuyerRef will always have a reference of searchPastBuyer value
  const pastBuyerRef = useRef();
  pastBuyerRef.current = searchPastBuyer;
  const navigate = useNavigate();
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    refetch();
  }, [
    searchPastBuyer,
    location?.state?.propertyId
  ]);

  const fetchClients = () => {
    const options = {
      method: 'POST',
      url: '/buyer/getmobilebuyerlist',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        negotiatorId: staffMemberId,
        searchPastBuyers: pastBuyerRef.current,
      }),
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const postBuyerProperties = () => {
    let data = [];

    checked.forEach((buyerSpecId) => {
      data.push(
        {
          BuyerSpecId: parseInt(buyerSpecId),
          PropertyId: location?.state?.propertyId,
          Status: 3
        }
      )
    });

    const options = {
      method: 'POST',
      url: '/BuyerProperty/AddFromCrossMatch',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(options)
      .then((response) => {
        toast.success(
          `Properties added successfully`,
          {
            position: 'top-center',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        navigate(-1);
      })
      .catch((error) => {
        toast.error(`Sorry, server error, try again later`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const {
    isLoading: isLoadingClients,
    isError,
    data: ClientsData,
    refetch
  } = useQuery('ClientsData', fetchClients, {
    refetchOnWindowFocus: false,
    enabled: false // turned off by default, manual refetch is needed
  });

  const filterClient = (clients, search) => {
    if (!search) {
      return clients;
    }

    return clients.filter((client) => {
      if (client?.address?.addressIndividualFirstName != null) {
        return (
          client?.address?.addressIndividualFirstName?.toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.address?.addressIndividualSurname?.toLowerCase()
            .includes(search.toLowerCase()) ||
          client?.buyerSpec?.buyerSpecName?.toLowerCase()
            .includes(search.toLowerCase())
        );
      }
    });
  };

  const filterClients = filterClient(ClientsData, search);

  const handleCloseModal = (event) => {
    navigate(-1);
  }

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  if (isLoadingClients) {
    return <CenteredSpinner />;
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <Modal show={true}>
      <Modal.Header
          closeButton
          onClick={handleCloseModal}
        >
          <Modal.Title><span className='font-weight-bold'>Add Property To Buyer</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="container p-0">
      <div className="row justify-content-center align-items-center">
        <div className="col-12 col-md-12 col-xl-12">
          <div className="h6 mb-3 ml-0">
            You have{' '}
            {filterClients?.length > 1
              ? `${filterClients?.length} clients`
              : `${filterClients?.length} client`}
          </div>
          <div className='row'>
            <div className='col-md-12'>
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback"></span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        {filterClients?.length < 1 ? (
          <h4>No search results found</h4>
        ) : null}
        <div className="col-12 col-md-12 col-xl-12">
          <div className="form-group mt-4">
            <div className="pb-4">
              {filterClients &&
                React.Children.toArray(
                  filterClients?.map((buyer) => (
                    <div className="border-bottom">
                      <div
                        className="pb-2 d-flex justify-content-between"
                      >
                        <div className="font-weight-bold cursor-item">
                          <label>
                            <input type="checkbox" value={buyer?.buyerSpecId} onChange={handleCheck} />&nbsp;
                            {
                              getAddressFullName(buyer?.address) === '' ? buyer?.buyerSpec?.buyerSpecName : getAddressFullName(buyer?.address)
                            }
                          </label>
                        </div>
                        <small>Buyer Ref: {buyer?.buyerRef}</small>
                      </div>
                    </div>
                  )),
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
        </Modal.Body>
        <Modal.Footer>
        <Button
        variant='danger'
            onClick={handleCloseModal}
          >
              Cancel
          </Button>
          <Button
            onClick={postBuyerProperties}
          >
              Add
          </Button>
        </Modal.Footer>
    </Modal>
    
  );
};
